import { store } from 'app/store';
import axios from 'axios';
import { ProfileFormModel } from 'pages/Profile/profile.interface';
import { UserInterface } from 'store/userInfo/userInfoSlice.interface';
import urls from 'utils/urls';

export const getUserService: () => Promise<{ data: UserInterface }> = () => {
  try {
    const state = store.getState();
    const userInfo = state.userInfo.userInfo.data;
    if (userInfo) {
      return Promise.resolve({ data: userInfo });
    } else {
      return axios
        .get(urls.users)
        .then((res) => {
          return { data: res.data.response as UserInterface };
        })
        .catch((err: Error) => {
          throw err;
        });
    }
  } catch (ex) {
    return Promise.reject(ex);
  }
};

export const updateUserService = (data: Partial<ProfileFormModel>) => {
  return axios
    .put(urls.users, data)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
